import React from 'react';

function Modal({
    title,
    confirmText,
    closeText,
    onConfirm,
    ...props
}) {

    function handleConfirm(event) {
        onConfirm();
    }

    return (
        <div className='modal fade' id={props.id} data-bs-backdrop='static' data-bs-keyboard="false" tabIndex="-1">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="staticBackdropLabel">{title}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        {props.children}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">{closeText}</button>
                        <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={handleConfirm}>{confirmText}</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Modal;